module.exports = __webpack_public_path__ + "static/media/login_bg.a4c29458.png";